export const SET_SYSTEM_INFO = 'SET_SYSTEM_INFO'
// 个人信息
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO'
export const SET_ADMIN_ACCESS = 'SET_ADMIN_ACCESS'
export const SET_NEW_USER = 'SET_NEW_USER'
export const SET_CREATE_STEP = 'SET_CREATE_STEP'
// libInfo
export const SET_LIB_INFO = 'SET_LIB_INFO'
export const SET_LIB_LIST = 'SET_LIB_LIST'
// publicationInfo
export const SET_PUBLICATION_INFO = 'SET_PUBLICATION_INFO'
export const SET_MAGAZINE_LIST = 'SET_MAGAZINE_LIST'
// magazine
export const SET_MAGAZINE_CONFIG = 'SET_MAGAZINE_CONFIG'
export const SET_MAGAZINE_INFO = 'SET_MAGAZINE_INFO'
